import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "members" }
const _hoisted_2 = { class: "members-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spaces_user = _resolveComponent("spaces-user")!
  const _component_spaces_user_transition = _resolveComponent("spaces-user-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_spaces_user_transition, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.my, (contact) => {
            return (_openBlock(), _createBlock(_component_spaces_user, {
              key: contact.user.accountId,
              user: contact.user,
              "user-type": _ctx.NETWORK_CONTACT_TYPES.GROUP_INVITATION,
              "users-to-add": _ctx.usersToAdd,
              "users-to-invite": _ctx.usersToInvite,
              onHandleUser: _ctx.handleUser
            }, null, 8, ["user", "user-type", "users-to-add", "users-to-invite", "onHandleUser"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}